// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"12da1222","415":"e51e3614","451":"b2dbb9a0","577":"00912be0","763":"5f139871"}[chunkId] + ".chunk.js";
};